import React from 'react'
import { render } from 'react-dom'
import { Router, Route } from 'react-router-dom'
import { Provider } from 'react-redux'
import { I18nextProvider } from 'react-i18next'
import createBrowserHistory from 'history/createBrowserHistory'

import i18n from './i18n/i18n'
import configureStore from './store'
import App from './App'
import './index.css'

const store = configureStore()
const history = createBrowserHistory()

render(
  <Provider store={store}>
    <Router history={history}>
      <I18nextProvider i18n={i18n}>
        <div>
          <Route exact path='/' render={props => <App {...props} view='home' />} />
          <Route exact path='/project/:projectId' render={props => <App {...props} view='project' />} />
          <Route
            exact
            path='/project/:projectId/settings'
            render={props => <App {...props} view='project-settings' />}
          />
          <Route exact path='/settings' render={props => <App {...props} view='settings' />} />
          <Route
            exact
            path='/settings/company/:companyId'
            render={props => <App {...props} view='settings-company' />}
          />
          <Route exact path='/hubspot' render={props => <App {...props} view='hubspot' />} />
        </div>
      </I18nextProvider>
    </Router>
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js